import * as yup from 'yup'

export const walmartWebhookQuerySchema = yup.object({
  organizationId: yup.string().required(),
})

export const walmartOrderUpdateWebhookSchema = yup.object().shape({
  eventType: yup.string().required(),
  generatedTime: yup.string().required(),
  orderId: yup.string().required(),
  customerOrderId: yup.string().required(),
  orderSource: yup.string().required(),
  storeNumber: yup.string().required(),
  requestId: yup.string().required(),
  status: yup
    .object()
    .shape({
      description: yup.string().required(),
      reason: yup
        .object()
        .shape({
          code: yup.number().required(),
          description: yup.string().required(),
        })
        .notRequired(),
    })
    .required(),
})
